export interface Experience {
  company: string;
  position: string;
  period: string;
  description: string;
  type?: '정규직' | '외주' | '인턴';
  projects: {
    title: string;
    description: string;
    period?: string;
    technologies: string[];
    achievements?: string[];
  }[];
}

export const experiences: Experience[] = [
  {
    company: '이팝콘',
    position: '웹 스크래핑 개발자 (외주)',
    period: '2022.03 - 2022.12',
    type: '외주',
    description: '해외 쇼핑몰 사이트 동적 스크래핑 시스템 개발을 담당했습니다. Puppeteer와 Cheerio를 활용하여 20개 이상의 해외 쇼핑몰 사이트에서 상품 정보를 자동으로 수집하는 시스템을 구축했습니다.',
    projects: [
      {
        title: '해외 쇼핑몰 동적 스크래핑 시스템',
        description: '20개 이상의 해외 쇼핑몰 사이트에서 상품 정보를 자동으로 수집하는 동적 스크래핑 시스템을 개발했습니다. 각 사이트의 구조에 맞춰 동적으로 스크래핑 로직을 구성하고, 안정적인 데이터 수집을 위한 에러 핸들링 및 재시도 메커니즘을 구현했습니다.',
        technologies: ['TypeScript', 'Cheerio', 'Puppeteer', 'Node.js'],
        achievements: [
          '20개 이상의 해외 쇼핑몰 사이트 동적 스크래핑 시스템 구축',
          'Puppeteer를 활용한 JavaScript 렌더링 페이지 스크래핑 구현',
          'Cheerio를 활용한 정적 HTML 파싱 및 데이터 추출',
          '각 사이트별 커스텀 스크래핑 로직 설계 및 구현',
          '에러 핸들링 및 재시도 메커니즘으로 안정성 향상',
          '대량 데이터 수집을 위한 비동기 처리 최적화'
        ]
      }
    ]
  },
  {
    company: '소프트스퀘어드 (외주팀)',
    position: '백엔드 개발자 (프리랜서)',
    period: '2023.02 - 2023.06',
    type: '외주',
    description: '교보문고 REST API 개발 외주 프로젝트를 담당했습니다. Spring Boot 기반의 회원관리 시스템을 개발하며, 안정적이고 확장 가능한 API 설계에 집중했습니다.',
    projects: [
      {
        title: '교보문고 REST API 개발',
        description: '교보문고 플랫폼을 위한 REST API 개발 프로젝트로, 회원관리 시스템을 중심으로 개발했습니다. Spring Boot와 Java를 활용하여 안정적이고 확장 가능한 백엔드 시스템을 구축했습니다.',
        technologies: ['Spring Boot', 'Java', 'REST API', 'JPA'],
        achievements: [
          '교보문고 회원관리 REST API 개발',
          'Spring Boot 기반 백엔드 아키텍처 설계 및 구현',
          'RESTful API 설계 원칙 준수 및 문서화',
          '회원 인증 및 권한 관리 시스템 구현',
          '데이터베이스 설계 및 JPA를 활용한 데이터 레이어 구축'
        ]
      }
    ]
  },
  {
    company: '매치 컴퍼니',
    position: '백엔드 개발 인턴 (현장실습)',
    period: '2023.06 - 2023.12',
    type: '인턴',
    description: '기부 플랫폼 MATCH 프로젝트에서 백엔드 개발자로 현장실습을 진행했습니다. Master-Slave DB 구조 설계 및 AOP 기반 결제 예외 처리 시스템을 구축하며, 안정적이고 확장 가능한 백엔드 아키텍처 설계 경험을 쌓았습니다.',
    projects: [
      {
        title: 'MATCH - 기부 플랫폼',
        description: '안정적이고 확장 가능한 기부 플랫폼으로, Master-Slave DB 구조를 통한 읽기 성능 최적화와 AOP 기반 결제 예외 처리 시스템을 구축했습니다. 금융 거래의 안정성과 데이터 일관성을 보장하는 아키텍처를 설계했습니다.',
        technologies: ['Spring Boot', 'Java', 'MySQL', 'Master-Slave DB', 'AOP', 'Payment API', 'JPA', 'Redis', 'Spring Security'],
        achievements: [
          'Master-Slave DB 구조로 읽기 쿼리 분산 처리, 읽기 성능 60% 향상',
          'AOP를 활용한 결제 예외 처리 및 로깅 시스템 구축으로 코드 중복 제거',
          '트랜잭션 관리 최적화 및 Redisson Lock 적용으로 데이터 일관성 보장',
          '결제 실패 시 자동 롤백 및 알림 시스템 구현',
          'Redis를 활용한 결제 세션 관리로 중복 결제 방지',
          'Spring Security를 통한 결제 API 인증 및 권한 관리',
          '팀원들과의 협업을 통한 코드 리뷰 및 베스트 프랙티스 공유',
          '실무 환경에서의 개발 프로세스 및 협업 경험'
        ]
      }
    ]
  },
  {
    company: '소프트스퀘어드 (외주팀)',
    position: '백엔드 개발자 (프리랜서)',
    period: '2023.10 - 2024.03',
    type: '외주',
    description: '한화시스템 REST API 개발 외주 프로젝트를 담당했습니다. 주문, 공간관리, 리뷰, 1:1문의 등 다양한 비즈니스 로직을 구현하며, 복잡한 도메인 모델링과 API 설계 경험을 쌓았습니다.',
    projects: [
      {
        title: '한화시스템 REST API 개발',
        description: '한화시스템을 위한 REST API 개발 프로젝트로, 주문 관리, 공간 관리, 리뷰 시스템, 1:1 문의 등 다양한 기능을 구현했습니다. Spring Boot와 Java를 활용하여 안정적이고 확장 가능한 백엔드 시스템을 구축했습니다.',
        technologies: ['Spring Boot', 'Java', 'REST API', 'JPA', 'Spring Security'],
        achievements: [
          '주문 관리 시스템 API 개발',
          '공간 관리 시스템 API 개발',
          '리뷰 시스템 API 개발',
          '1:1 문의 시스템 API 개발',
          '복잡한 비즈니스 로직 구현 및 도메인 모델링',
          'RESTful API 설계 및 문서화',
          'Spring Security를 활용한 인증/인가 시스템 구축'
        ]
      }
    ]
  },
  {
    company: '(주)엔에스원소프트',
    position: '풀스택 개발자',
    period: '2024.04 - 현재',
    type: '정규직',
    description: '다양한 공공기관 및 인프라 프로젝트에서 풀스택 개발을 담당하며, 실시간 모니터링 시스템과 고도화 프로젝트를 리드했습니다. Spring Boot 기반의 마이크로서비스 아키텍처 설계 및 구현, 실시간 데이터 처리 시스템 구축, 성능 최적화에 집중했습니다.',
    projects: [
      {
        title: '한국해양안전교통공단 고도화 프로젝트',
        description: '해양안전 관련 시스템의 전반적인 고도화 및 성능 개선 프로젝트로, 레거시 시스템을 Spring Boot 기반으로 마이그레이션하고 성능 최적화를 수행했습니다.',
        technologies: ['Spring Boot', 'Java', 'JPA', 'Oracle', 'Redis', 'Spring Security', 'REST API'],
        achievements: [
          '레거시 시스템 분석 및 Spring Boot 기반 마이그레이션 수행',
          '쿼리 최적화 및 인덱싱 전략 수립으로 응답 시간 40% 개선',
          'Redis 캐싱 전략 도입으로 DB 부하 50% 감소 및 응답 속도 향상',
          'RESTful API 설계 및 문서화로 프론트엔드 협업 효율성 향상',
          'Spring Security를 활용한 인증/인가 시스템 구축',
          '배치 작업 최적화로 대용량 데이터 처리 성능 개선'
        ]
      },
      {
        title: '스마트 맨홀 모니터링 시스템',
        description: 'IoT 센서를 활용한 맨홀 상태 실시간 모니터링 시스템으로, 대량의 센서 데이터를 실시간으로 수집, 처리, 시각화하는 시스템을 구축했습니다. GS 인증을 획득하고 은평구청, 구로구청에 배포되었습니다.',
        technologies: ['Spring Boot', 'Java', 'WebSocket', 'Redis', 'MQTT', 'JPA', 'MariaDB'],
        achievements: [
          'GS 인증 획득 및 은평구청, 구로구청에 정식 배포',
          'MQTT 프로토콜을 활용한 IoT 센서 데이터 수집 시스템 구축',
          'WebSocket을 활용한 실시간 양방향 통신으로 대시보드 업데이트 구현',
          'Redis Streams를 활용한 실시간 데이터 처리 파이프라인 구축',
          '이상 감지 알고리즘 구현 및 자동 알림 시스템 구축'
        ]
      },
      {
        title: '무인역사 시스템',
        description: '무인역사 운영을 위한 실시간 알림 및 모니터링 시스템으로, SSE(Server-Sent Events)와 Redis Pub/Sub을 활용한 실시간 이벤트 전달 시스템을 구현했습니다.',
        technologies: ['Spring Boot', 'Java', 'SSE', 'Redis Pub/Sub', 'WebFlux', 'Reactive Programming', 'JPA', 'MariaDB'],
        achievements: [
          'Server-Sent Events(SSE)를 활용한 서버-클라이언트 실시간 단방향 통신 구현',
          'Redis Pub/Sub 패턴으로 확장 가능한 이벤트 기반 아키텍처 설계',
          'WebFlux를 활용한 논블로킹 I/O 처리로 동시 접속자 수 대폭 증가',
          '이벤트 기반 아키텍처로 시스템 간 결합도 감소 및 확장성 향상',
          '실시간 알림 전달률 99.9% 달성',
          '장애 상황 시 자동 재연결 및 메시지 큐잉 시스템 구현',
          'Redis Delayed Queue(RedelayQueue)를 활용한 지연 실행 스케줄링 작업 시스템 구현'
        ]
      },
      {
        title: 'LTE-R 철탑기울기 모니터링 시스템',
        description: 'GIS(지리정보시스템) 기반 철탑 상태 모니터링 및 경고 시스템으로, 대용량 위치 데이터와 센서 데이터를 실시간으로 처리하고 분석하는 시스템을 구축했습니다.',
        technologies: ['Spring Boot', 'Java', 'PostGIS', 'GIS', 'Redis Pub/Sub', 'JPA', 'PostgreSQL', 'Geospatial Data'],
        achievements: [
          'PostGIS를 활용한 지리공간 데이터 처리 및 쿼리 최적화',
          'Redis Streams를 활용한 대용량 센서 데이터 스트리밍 처리',
          'GIS 데이터와 센서 데이터의 실시간 결합 분석 시스템 구축',
          '기울기 임계값 기반 자동 경고 시스템 구현',
          '지도 기반 시각화를 위한 RESTful API 설계 및 구현',
          '대용량 지리공간 데이터 처리 성능 최적화로 응답 시간 60% 개선',
          'Redis Streams를 활용한 수평 확장 가능한 아키텍처 설계'
        ]
      },
      {
        title: '국방부 P5G BS 시스템',
        description: 'Private 5G 네트워크의 개통관리 시스템으로, SIM 카드 및 단말 자원 관리부터 개통 요청 및 승인 처리까지 전 과정을 자동화하는 통합 관리 플랫폼을 개발했습니다. Kubernetes 기반의 컨테이너 환경에서 고가용성과 확장성을 보장하는 마이크로서비스 아키텍처를 설계했습니다.',
        technologies: ['Spring Boot', 'Java', 'Next.js', 'TypeScript', 'Kubernetes', 'Docker', 'MariaDB', 'JPA', 'REST API'],
        achievements: [
          'SIM 제작요청 API 개발 및 프론트엔드 연동으로 IMSI, ICCID 값 자동 생성 및 Input 파일 생성 시스템 구축',
          'SIM 자원 승인 프로세스 개발: OPC 값 생성 로직 및 전반적인 승인 API 구현',
          '단말 자원 관리 시스템 개발: 엑셀 양식 업로드 기능 및 단말 관련 CRUD API 전반 구현',
          '요청관리 모듈 개발: 개통 요청부터 변경 요청까지 전 생명주기 관리 시스템 구축',
          '자원할당 시스템 개발: SIM-단말 매핑 및 자원 배정 프로세스 자동화',
          '서비스할당 모듈 개발: Private 5G 서비스 할당 및 관리 기능 구현',
          '승인처리 워크플로우 개발: 프로비저닝 단계 이전까지의 전체 승인 프로세스 자동화'
        ]
      }
    ]
  },
  {
    company: 'doitnow(외주팀)',
    position: '백엔드 개발자 (외주)',
    period: '2025.08 - 2025.12',
    type: '외주',
    description: 'Nia 작품 보관 서비스 개발 프로젝트를 담당했습니다. Spring Boot와 Java를 활용하여 사용자 인증 시스템과 ERD 설계를 포함한 전반적인 백엔드 시스템을 구축했습니다. 총 20개 이상의 기능 모듈을 개발했습니다.',
    projects: [
      {
        title: 'Nia 작품 보관 서비스',
        description: '작품 보관 및 관리 서비스를 위한 백엔드 시스템 개발 프로젝트입니다. Spring Boot와 Java를 활용하여 사용자 인증/인가 시스템, 작품 관리, 수장고 관리, 통계 등 다양한 기능을 구현했습니다. ERD 설계부터 API 개발까지 전 과정을 담당했습니다.',
        technologies: ['Spring Boot', 'Java', 'Spring Security', 'JPA', 'REST API'],
        achievements: [
          '사용자 인증/인가 시스템 개발 (로그인, 회원가입, 회원관리)',
          '작품 관리 시스템 개발 (작품 추가, 목록 조회, 상세 조회)',
          '개인 수장고 및 BOHO 수장고 관리 시스템 개발',
          '수장고 상세 정보 관리 API 개발',
          '마이페이지 기능 개발',
          '공지사항 및 약관 관리 시스템 개발',
          '고객센터 기능 개발',
          '알림 시스템 개발',
          '수장고 관리 및 보관현황 관리 시스템 개발',
          '수거/입고 현황 관리 시스템 개발',
          '통계 기능 개발',
          '관리자 계정 관리 시스템 개발',
          'ERD 설계 및 데이터베이스 구조 설계',
          '총 20개 이상의 기능 모듈 개발 완료'
        ]
      }
    ]
  }
];
